<template>
  <div class="account-config-wrapper global-card">
    <bread-crumb />
    <div class="account-config-card">
      <form-card
        ref="formcard1"
        title="个人资料"
        :form-data="formData1"
        class="user-info-form"
        :gutter="48"
      >
        <template #real_name>
          <a-input
            v-decorator="['real_name',
                          {rules: [{ required: true, message: '请输入姓名' }],}
            ]"
          />
        </template>
        <template #phone>
          <a-input
            v-decorator="['phone', {rules: [{ required: true, message: '请输入手机号' }],}]"
          />
        </template>
        <template #id>
          <a-row :gutter="12">
            <a-col :span="12">
              <a-input
                v-decorator="['id']"
                disabled
              />
            </a-col>
            <a-col :span="12">
              <span
                style=" line-height: 20px;
  color: #c3c7d5;
  font-size: 14px;"
              >账号唯一不重复</span>
            </a-col>
          </a-row>
        </template>
        <template #provinceCity>
          <province-city
            v-decorator="[
              'provinceCity',
              {rules: [{ required: true, validator: checkProvinceCity}],}
            ]"
          />
        </template>
        <template #qichacha_name>
          <a-input
            v-decorator="['qichacha_name']"
            disabled
          />
        </template>
        <template #address>
          <a-input
            v-decorator="['address']"
          />
        </template>
      </form-card>
      <form-button
        class="form-card-button"
        :btn-is-loading="btnIsLoading"
        cancel-text="返回"
        @onSubmit="onSubmit"
        @onCancel="onCancel"
      />
    </div>
  </div>
</template>
<script>
import { formData1} from './data/index';
export default {
  data() {
    return {
      formData1,
      btnIsLoading: false,
    };
  },
  created() {
    // 获取管路员信息
    this.getUserInfo();
  },
  methods: {
    // 获取管路员信息
    async getUserInfo() {
      let result = await this.$http.post('/manager/getCompanyManagerInfo');
      if (result.data.status === 1) {
        let res = result.data.data;
        let data = {
          real_name: res.real_name,
          phone: res.phone,
          qichacha_name: res.company.team_name,
          address: res.address,
          id: res.id,
          provinceCity: { province: res.province, city: res.city },
        };
        this.$refs.formcard1.form.setFieldsValue(data);
      }
    },
    // 修改
    onSubmit() {
      this.$refs.formcard1.form.validateFields(async(err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
          this.btnIsLoading=true;
          values.province=values.provinceCity.province;
          values.city=values.provinceCity.city;
          values.path=`0,${values.provinceCity.province},${values.provinceCity.city}`;
          let result = await this.$http.post('/manager/updateCompanyManager', {
            ...values,
            editFlag: '1',
          });
          this.btnIsLoading=false;
          if (result.data.status === 1) {
            this.$message.success('操作成功！');
          }
        }
      });

    },
    // 取消
    onCancel() {
      this.$router.back();
    },
    // 自定义省市校验
    checkProvinceCity(rule, value, callback) {
      const error = [];
      if (!value || !value.province) {
        error.push('省份');
      }
      if (!value || !value.city) {
        error.push('城市');
      }
      if (error.length === 0) {
        callback();
      }
      callback(`请选择${error.join('和')}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.account-config-card{
   background: #fff;
   padding:32px;
  border-radius: 10px;
  padding-bottom: 0;
  .form-card-button {
    background: #f9f9fc;
    margin: 60px -32px -24px -32px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
      transform: translateY(10px);

  }
}
</style>
